import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "store";
import { AuthProvider } from "contexts/AuthContext";
import App from "./App";
import { applyDarkModeToDocument, readDarkModePreference } from "utils/theme";

import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "assets/css/public.css";

// Apply saved theme before React paint (authenticated routes only)
try {
  const isDark = readDarkModePreference();
  applyDarkModeToDocument(isDark, window.location.pathname);
} catch {
  // ignore
}

const rootElement = document.getElementById("root");
if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);

  root.render(
    <Provider store={store}>
      <AuthProvider>
        <App />
      </AuthProvider>
    </Provider>
  );
}
